/* @flow */

import { rem } from 'polished';

import {
  baseFontSize,
  headlineFontSize,
  headlineFontWeight,
  headlineLineHeight,
  subheading1FontSize,
  subheading1FontWeight,
  subheading1LineHeight,
  subheading2FontSize,
  subheading2FontWeight,
  subheading2LineHeight,
} from '@braindate/ui/lib/token/typography';

export default {
  h1: {
    margin: [rem(40, baseFontSize), 0, rem(20, baseFontSize)],

    fontSize: rem(headlineFontSize, baseFontSize),
    fontWeight: headlineFontWeight,
    lineHeight: headlineLineHeight / headlineFontSize,
  },
  h2: {
    margin: [rem(32, baseFontSize), 0, rem(16, baseFontSize)],

    fontSize: rem(subheading1FontSize, baseFontSize),
    fontWeight: subheading1FontWeight,
    lineHeight: subheading1LineHeight / subheading1FontSize,
  },
  h3: {
    margin: [rem(24, baseFontSize), 0, rem(12, baseFontSize)],

    fontSize: rem(subheading2FontSize, baseFontSize),
    fontWeight: subheading2FontWeight,
    lineHeight: subheading2LineHeight / subheading2FontSize,
  },
};
